import { render } from "./App.vue?vue&type=template&id=5c60c2c3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c60c2c3&lang=css"

import exportComponent from "/builds/fa4daba7/0/develop/front_payments_config/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__